module.exports = __webpack_public_path__ + "img/back2.c4f2f3c4.jpg";